<template>
<div>
  <vb-form-row item-name="電話番号" :required="true">
    <template #input>
      <v-sheet class="col-4 pa-0" max-width="164">
        <validation-provider v-slot="{ errors, invalid }" name="電話番号1" rules="required|numeric|max:5">
          <v-text-field
            :value="formItemsGetter.telephoneNumber1"
            @input="formItemsSetter({name:'telephoneNumber1', value: $event})"
            @blur="formItemsSetter({name:'telephoneNumber1', value: toHalfSize($event.target.value)}); blurBgColorChange($event, errors[0]);"
            @focus="focusBgColorChange($event, errors[0])"
            :error-messages="errors"
            outlined
            required
            dense
            height="44px"
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            class="pr-0"
            name="telephoneNumber1"
            hide-details="auto"
            append-outer-icon="mdi-minus"
            solo
            flat
          />
        </validation-provider>
      </v-sheet>
      <v-sheet class="col-4 pa-0" max-width="164">
        <validation-provider v-slot="{ errors, invalid }" name="電話番号2" rules="required|numeric|max:5">
          <v-text-field
            :value="formItemsGetter.telephoneNumber2"
            @input="formItemsSetter({name:'telephoneNumber2', value: $event})"
            @blur="formItemsSetter({name:'telephoneNumber2', value: toHalfSize($event.target.value)}); blurBgColorChange($event, errors[0]);"
            @focus="focusBgColorChange($event, errors[0])"
            :error-messages="errors"
            outlined
            required
            dense
            height="44px"
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            class="pl-2 pr-0"
            name="telephoneNumber2"
            hide-details="auto"
            append-outer-icon="mdi-minus"
            solo
            flat
          />
        </validation-provider>
      </v-sheet>
      <v-sheet class="col-4 pa-0" max-width="132">
        <validation-provider v-slot="{ errors, invalid }" name="電話番号3" rules="required|numeric|max:5">
          <v-text-field
            :value="formItemsGetter.telephoneNumber3"
            @input="formItemsSetter({name:'telephoneNumber3', value: $event})"
            @blur="formItemsSetter({name:'telephoneNumber3', value: toHalfSize($event.target.value)}); blurBgColorChange($event, errors[0]);"
            @focus="focusBgColorChange($event, errors[0])"
            :error-messages="errors"
            outlined
            required
            dense
            height="44px"
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            name="telephoneNumber3"
            class="pl-2"
            hide-details="auto"
            solo
            flat
          />
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import InputValueConversion from "../../../libs/InputValueConversion.js";
import VbFormRow from "../buy/vb-form-row.vue";

export default {
  name: "vb-phone-number",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  methods: {
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    toHalfSize(value) {
      return InputValueConversion.toHalfSize(value);
    },
  }
}
</script>

<style scoped>

</style>